<template>
  <div>
    <AInputNumber placehoder="مقدار"
                  @change="search"
                  v-model="input"/>
  </div>
</template>

<script>
export default {
  name: 'NumberXTableFilter',
  props: ['value'],
  data() {
    return {
      input: undefined
    }
  },
  methods: {
    search() {
      this.$emit('input', this.input)
    },
  },
  mounted() {
    this.input = this.value
  }
}
</script>
